import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Box,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import PreviewFastJobPosting from '../../Components/Body/PreviewFastJobPosting';

const ControlFastPosts = () => {
  const [posts, setPosts] = useState([]);
  const [selectedPost, setSelectedPost] = useState(null);
  const [open, setOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [pendingApprove, setPendingApprove] = useState(null);
  const [shareLinkedIn, setShareLinkedIn] = useState(true);

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    try {
      const response = await axios.get('https://kariyer.biyomed.net/api/posts/get-fast-post');
      const sortedUsers = response.data.posts.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      setPosts(sortedUsers);
    } catch (error) {
      console.error('API isteği başarısız:', error);
    }
  };

const handleLinkedInShare = async (id) => {
  try {
    await axios.post(
      'https://kariyer.biyomed.net/api/admin/linkedin-share-fast-post',
      { id },
      { withCredentials: true }
    );
    alert('LinkedIn paylaşımı başarılı!');
  } catch (error) {
    console.error('LinkedIn paylaşım hatası:', error);
    alert('LinkedIn paylaşımı başarısız.');
  }
};

const handleApproveClick = (post) => {
  setPendingApprove(post);
  setShareLinkedIn(true);
  setConfirmOpen(true);
};

const handleApproveConfirm = async () => {
  if (!pendingApprove) return;
  setConfirmOpen(false);
  try {
    await axios.post(
      'https://kariyer.biyomed.net/api/admin/approve-fast-post',
      { id: pendingApprove.id, email: pendingApprove.email, shareToLinkedIn: shareLinkedIn },
      { withCredentials: true }
    );
    alert('İlan onaylandı!' + (shareLinkedIn ? ' LinkedIn\'e paylaşıldı.' : ''));
    fetchPosts();
  } catch (error) {
    console.error('Onaylama hatası:', error);
  } finally {
    setPendingApprove(null);
  }
};

const handleDelete = async (id, email) => {
  try {
    await axios.post(
      'https://kariyer.biyomed.net/api/admin/delete-fast-post',
      { id, email },
      { withCredentials: true }
    );
    alert('İlan silindi!');
    fetchPosts();
  } catch (error) {
    console.error('Silme hatası:', error);
  }
};


  const handlePreviewOpen = (post) => {
    setSelectedPost(post);
    setOpen(true);
  };

  const handlePreviewClose = () => {
    setOpen(false);
    setSelectedPost(null);
  };

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        Hızlı İlanlar
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Ad Soyad</TableCell>
              <TableCell>E-posta</TableCell>
              <TableCell>Firma Adı</TableCell>
              <TableCell>Pozisyon Adı</TableCell>
              <TableCell>Durum</TableCell>
              <TableCell>Oluşturma Tarihi</TableCell>
              <TableCell align="center">İşlemler</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {posts.map((post) => (
              <TableRow key={post.id}>
                <TableCell>{post.full_name}</TableCell>
                <TableCell>{post.email}</TableCell>
                <TableCell>{post.company_name}</TableCell>
                <TableCell>{post.position_name}</TableCell>
                <TableCell sx={{ color: post.job_status ? "green" : "red", fontWeight: "bold" }}>
                  {post.job_status ? "Onaylandı" : "Onaylanmadı"}
                </TableCell>
                <TableCell>{new Date(post.created_at).toLocaleString()}</TableCell>
                <TableCell align="center">
                  <Box display="flex" gap={1} justifyContent="center">
                    <Button
                      variant="contained"
                      color="warning"
                      size="small"
                      onClick={() => handlePreviewOpen(post)}
                    >
                      İlan önizlemesi
                    </Button>
                    <Button
                      variant="contained"
                      color="success"
                      size="small"
                      disabled={post.job_status}
                      onClick={() => handleApproveClick(post)}
                    >
                      Onayla
                    </Button>
                    <Button
                      variant="contained"
                      color="error"
                      size="small"
                      onClick={() => handleDelete(post.id, post.email)}
                    >
                      Sil
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      startIcon={<LinkedInIcon />}
                      sx={{ backgroundColor: '#0a66c2', '&:hover': { backgroundColor: '#004182' } }}
                      onClick={() => handleLinkedInShare(post.id)}
                    >
                      Paylaş
                    </Button>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
            {posts.length === 0 && (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  Kayıt bulunamadı.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Onay Popup */}
      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)} maxWidth="xs" fullWidth>
        <DialogTitle>İlanı Onayla</DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom>
            <strong>{pendingApprove?.position_name}</strong> pozisyonunu onaylamak istediğinize emin misiniz?
          </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={shareLinkedIn}
                onChange={(e) => setShareLinkedIn(e.target.checked)}
                color="primary"
              />
            }
            label={
              <Box display="flex" alignItems="center" gap={0.5}>
                <LinkedInIcon fontSize="small" sx={{ color: '#0a66c2' }} />
                <span>LinkedIn'de paylaş</span>
              </Box>
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)}>İptal</Button>
          <Button variant="contained" color="success" onClick={handleApproveConfirm}>
            Onayla
          </Button>
        </DialogActions>
      </Dialog>

      {/* Önizleme Popup */}
      <Dialog open={open} onClose={handlePreviewClose} maxWidth="md" fullWidth>
        <DialogTitle>
          İlan Önizlemesi
          <IconButton
            aria-label="close"
            onClick={handlePreviewClose}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {selectedPost && <PreviewFastJobPosting post={selectedPost} />}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ControlFastPosts;
